import {fromJS, Map} from 'immutable';
import newsActions from '../actions/news.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {CommonPost} from '../../shared/types';
import {uniquePosts} from '../utils/NewsUtils';

export interface NewsState {
    posts: CommonPost[];
    cursor: number;
    lastFetch?: number;
    lastFetchFailed: boolean;
    hasFetchedAllPosts: boolean;
    post: CommonPost;
    loading: false;
}

export const DEFAULT_STATE = fromJS({
    posts: [],
    cursor: 0,
    lastFetch: undefined,
    lastFetchFailed: false,
    hasFetchedAllPosts: false,
    post: {},
    loading: false
});

export const newsReducer = (state: Map<string, any> = DEFAULT_STATE, action) => {
    switch (action.type) {
        /**
         * FETCH NEWS
         */
        case newsActions.TYPES.GET_NEWS: {
            const {cursor = 0} = action.payload || {};
            return state.merge({
                cursor,
                loading: true
            });
        }
        case newsActions.TYPES.GET_NEWS_COMPLETE: {
            const {data: posts = []} = action.payload || {};
            return state.merge({
                posts: uniquePosts(state.get('posts').toJS(), posts),
                hasFetchedAllPosts: !posts.length,
                lastFetch: Date.now(),
                lastFetchFailed: false,
                loading: false
            });
        }
        case newsActions.TYPES.GET_NEWS_FAILED: {
            return state.merge({
                lastFetchFailed: true,
                loading: false
            });
        }

        /***
         * FETCH ARTICLE
         */
        case newsActions.TYPES.GET_ARTICLE: {
            return state.set('loading', true);
        }
        case newsActions.TYPES.GET_ARTICLE_COMPLETE: {
            const {data: post} = action.payload || {};
            return state.merge({
                post,
                loading: false
            });
        }
        case newsActions.TYPES.GET_ARTICLE_FAILED: {
            return state.set('loading', false);
        }

        /**
         * DEFAULT STATE
         */
        default:
            return state;
    }
};

export default dieselReducer('news', newsReducer);
